import { render, staticRenderFns } from "./RealnameAuth.vue?vue&type=template&id=771474c1&scoped=true"
import script from "./RealnameAuth.vue?vue&type=script&lang=js"
export * from "./RealnameAuth.vue?vue&type=script&lang=js"
import style0 from "./RealnameAuth.vue?vue&type=style&index=0&id=771474c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771474c1",
  null
  
)

export default component.exports